export default "c23383e45f29b689.svg"